import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const YoutubeIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.7248 16.7163L15.9066 14.9347C15.5734 14.78 15.2997 14.9534 15.2997 15.3223V18.6781C15.2997 19.047 15.5734 19.2204 15.9066 19.0657L19.7231 17.2841C20.058 17.1277 20.058 16.8727 19.7248 16.7163ZM16.9997 0.680176C7.98629 0.680176 0.679688 7.98678 0.679688 17.0002C0.679688 26.0136 7.98629 33.3202 16.9997 33.3202C26.0131 33.3202 33.3197 26.0136 33.3197 17.0002C33.3197 7.98678 26.0131 0.680176 16.9997 0.680176ZM16.9997 23.6302C8.64589 23.6302 8.49969 22.8771 8.49969 17.0002C8.49969 11.1233 8.64589 10.3702 16.9997 10.3702C25.3535 10.3702 25.4997 11.1233 25.4997 17.0002C25.4997 22.8771 25.3535 23.6302 16.9997 23.6302Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default YoutubeIcon;

YoutubeIcon.propTypes = customIconsPropTypes;
